import React from 'react'
import { Chip, Stack, Tooltip, Typography } from '@mui/material'

const PlusCodePreview = ({ googlePlusCode, citySlug = 'loja' }) => {
  const code = String(googlePlusCode || '').trim()
  const city = String(citySlug || 'loja').trim().toLowerCase() || 'loja'

  if (!code) return null

  return (
    <Stack spacing={0.6}>
      <Stack
        direction="row"
        spacing={0.75}
        alignItems="center"
        useFlexGap
        flexWrap="wrap">
        <Typography variant="body2" fontWeight={600}>
          Código GPS (Google Plus Code)
        </Typography>

        <Chip
          label={code}
          size="small"
          variant="outlined"
          color="info"
          sx={{
            fontFamily: 'monospace',
            fontWeight: 700,
            fontSize: '0.75rem',
          }}
        />

        <Tooltip title="El sufijo del árbol se genera automáticamente al guardar.">
          <span>
            <Chip
              label="+?"
              size="small"
              disabled
              variant="outlined"
              sx={{
                fontFamily: 'monospace',
                fontWeight: 700,
                fontSize: '0.75rem',
              }}
            />
          </span>
        </Tooltip>
      </Stack>

      <Typography variant="caption" color="text.secondary">
        Previsualización parcial - corresponde al cuadrante GPS
      </Typography>
      <Typography variant="caption" color="info.main" sx={{ fontFamily: 'monospace' }}>
        URL: /{city}/{code}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        El sufijo se asignará automáticamente al guardar
      </Typography>
    </Stack>
  )
}

export default PlusCodePreview
